import { render, staticRenderFns } from "./MobilePlans_variant2.vue?vue&type=template&id=4f91ea46"
import script from "./MobilePlans_variant2.vue?vue&type=script&lang=js"
export * from "./MobilePlans_variant2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports